import { point } from '../../../elements/point';
import { ICON_DEFAULT_FOREGROUND_COLOR } from '../../../graphConstants';
import { SvgPathBuilder } from '../../../svg/SvgPathBuilder';
import { makeTag } from '../../../svg/utils';
import {
  type NodeIconOptions,
  type NodeTypeIcon,
  nodeIconDefaultOptions,
} from '../NodeTypeIcon';
import {
  createCircleNodeTypeIcon,
  getArrowSvgPath,
  wrapNodeIconInSvgTag,
} from '../common';
import { drawCircleBackground } from '../drawIconBackground';

const DIAMETER = 40;
const DOUBLE_ARROW_BASE_Y = 10;
const DOUBLE_ARROW_TIP_Y = 17.2;
const DOUBLE_ARROW_HEAD_HALF_WIDTH = 4;
const DOUBLE_ARROW_TAIL_HALF_WIDTH = 1.6;

function createCloudRouterIcon(options: NodeIconOptions = {}): string {
  const opts = { ...nodeIconDefaultOptions, ...options };

  const getCloudRouterArrowSvg = (sign: 1 | -1) =>
    getArrowSvgPath({
      from: point.create(sign * 18, 0),
      to: point.create(sign * 3.6, 0),
      headWidth: 8,
      headHeight: 7.2,
      tailWidth: 3.2,
    });

  const doubleArrowPath = new SvgPathBuilder()
    .moveTo(0, -DOUBLE_ARROW_TIP_Y)
    .lineTo(DOUBLE_ARROW_HEAD_HALF_WIDTH, -DOUBLE_ARROW_BASE_Y)
    .hLineTo(DOUBLE_ARROW_TAIL_HALF_WIDTH)
    .vLineTo(DOUBLE_ARROW_BASE_Y)
    .hLineTo(DOUBLE_ARROW_HEAD_HALF_WIDTH)
    .lineTo(0, DOUBLE_ARROW_TIP_Y)
    .lineTo(-DOUBLE_ARROW_HEAD_HALF_WIDTH, DOUBLE_ARROW_BASE_Y)
    .hLineTo(-DOUBLE_ARROW_TAIL_HALF_WIDTH)
    .vLineTo(-DOUBLE_ARROW_BASE_Y)
    .hLineTo(-DOUBLE_ARROW_HEAD_HALF_WIDTH)
    .buildClosed();

  const arrows = makeTag('path', {
    d: `${getCloudRouterArrowSvg(1)} ${getCloudRouterArrowSvg(-1)} ${
      doubleArrowPath
    }`,
    fill: ICON_DEFAULT_FOREGROUND_COLOR,
  });

  const icon = `${drawCircleBackground(DIAMETER / 2, opts.style)}${arrows}`;

  return wrapNodeIconInSvgTag(icon, DIAMETER, DIAMETER, 'center', opts);
}

export const cloudRouterIcon: NodeTypeIcon = createCircleNodeTypeIcon(
  DIAMETER,
  createCloudRouterIcon,
);
